import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import { lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { Icon } from '../..';
import { contentStatus } from '../../../../constants';
import ToggleBox from '../../toggle-box';

const StatusFilter = ({
  onStatusChange,
  toggleFilter,
  showFilter,
  contentStatus
}) => {
  return (
    <div className='filter status-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'>
            {
              showFilter ?
                <Icon icon='minus-large'></Icon> :
                <Icon icon='plus-large'></Icon>
            }
            <span id='label'>Status</span>
          </h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Collapse id='status-filter' in={showFilter}>
          <div>
            <form id='selection-list'>
              <div>
                {
                  fp.flow(
                    fp.sortBy(association => association.label),
                    fp.map(
                      ({ value, label, selected }) => {
                        const boxLabel = selected ? <FiCheck /> : null
                        return <Row className={classNames('no-gutter flexbox align-center', { selected })} id='selection' key={value} onClick={
                          () => {
                            onStatusChange(value)
                          }
                        }>
                          <span id='checkbox'>
                            <ToggleBox
                              small
                              value={value}
                              label={boxLabel}
                              checked={selected} />
                          </span>
                          <span>{label}</span>
                        </Row>
                      }
                    )
                  )(contentStatus)
                }
              </div>
            </form>
          </div>
        </Collapse>
      </Row>
    </div>
  )
}

const getUpdatedStatus = (contentStatus, statusToToggle) => fp.flow(
  fp.map(
    (status) => ({
      ...status,
      selected: status.value === statusToToggle ? !status.selected : status.selected
    })
  )
)(contentStatus)

export default compose(
  withStateHandlers(
    {
      showFilter: false
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      })
    }
  ),
  withStateHandlers(
    () => ({
      contentStatus: fp.map(
        (status) => ({
          ...status,
          selected: false
        })
      )(contentStatus)
    }),
    {
      setStatus: () => (contentStatus) => ({
        contentStatus
      }),
      resetStatus: () => (filter) => ({
        contentStatus: fp.map(
          (status) => ({
            ...status,
            selected: fp.includes(status.value)(filter.status)
          })
        )(contentStatus)
      })
    }
  ),
  withHandlers({
    onStatusChange: ({ onChange, setStatus, contentStatus }) => (status) => {
      const updatedStatus = getUpdatedStatus(contentStatus, status)
      setStatus(updatedStatus)
      const selectedStatus = fp.flow(
        fp.filter('selected'),
        fp.map('value')
      )(updatedStatus)
      onChange({
        status: selectedStatus
      })
    }
  }),
  lifecycle({
    componentDidUpdate(prevStat) {
      const { filter, resetStatus } = this.props
      if (!fp.isEqual(filter)(prevStat.filter)) {
        resetStatus(filter)
      }
    }
  })
)(StatusFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/status-filter.js